import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getTagAll = (_params, onSuccess, onError) => {
    // _params.orders = 'tag:asc';
    const response = axios.get('v1/admin/tag', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getTagById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/tag/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createTag = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/tag`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateTag = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/tag/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteTag = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/tag/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deleteTag = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/tag/${id}`);
    return handleResponse(response, onSuccess, onError);
};